import React from "react";
import HyperModal from 'react-hyper-modal';
import IconButton from '@mui/material/IconButton';
import ReplyIcon from '@mui/icons-material/Reply';
import GitHubIcon from '@mui/icons-material/GitHub';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import './ProjectModal.scss';

const ProjectModal = ({ modalContent, closeModal, isModalOpen }) => {

    const openCode = () => {
        window.open(modalContent.code);
    }

    const openProject = () => {
        window.open(modalContent.demo);
    }

    return (
        <HyperModal
            isOpen={isModalOpen}
            requestClose={closeModal}
        >
            <div className="modal-data">

                <Typography gutterBottom variant="h5" component="div" className="text-center">
                    {modalContent.title} &nbsp;

                    {
                        modalContent.demo!=='' ? 
                        <IconButton aria-label="demo" onClick={openProject} >
                            <ReplyIcon />
                        </IconButton>
                        :
                        <IconButton aria-label="view code on github" onClick={openCode} >
                            <GitHubIcon />
                        </IconButton>
                    }
                </Typography>

                <Typography variant="body2" color="text.secondary">
                    {modalContent.brief}
                </Typography>

                <div className="modal-icons">
                    {/* <IconButton aria-label="view code on github" onClick={openCode} >
                        <GitHubIcon />
                    </IconButton> */}

                    
                </div>

                {
                    modalContent.description.map((description, index) => (
                        <Typography 
                            key={index} 
                            variant="body2" 
                            color="text.secondary" 
                            className="project-description"
                        >
                            {description}
                        </Typography>
                    ))
                }

                <Typography paragraph>Tech used</Typography>

                <div className="tech-stack">
                    {
                        modalContent.tech.map((tech, index) => (
                            <Chip 
                                key={index}
                                label={tech}
                                size="small" 
                                variant="outlined"
                            />
                        ))
                    }
                </div>
            </div>

        </HyperModal>
    );
}

export default ProjectModal;
